import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory, Link } from "react-router-dom";
import * as actions from "./_redux/Actions";
import { useSubheader } from "../../../_metronic/layout";
import { NotificationManager, NotificationContainer } from "react-notifications";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";

// import { Multiselect } from "multiselect-react-dropdown";
import {
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar,
  DatePickerField,
  TimePickerField,
  DateRangPickerField,
  Select,
  Input,
  Checkbox,
  Pagination,
} from "../../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import * as columnFormatters from "../../components/column-formatters";
import DeleteDialog from "../../components/DeleteDialog";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import { Col, Row, Accordion, Button } from "react-bootstrap";
import GamerjiTournamentSummeryDetails from "./GamerjiTournamentSummeryDetails";
import moment from "moment";
import DropdownReactSelect from "../../components/DropdownReactSelect";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

import * as UIHelpers from "../../components/UIHelpers";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import helperFunc from "../../../_metronic/_helpers/helperFunc";
import { NoRecordsFoundMessage, PleaseWaitMessage, sortCaret, headerSortingClasses } from "../../../_metronic/_helpers";
import ExportDataTableButton from "../../components/ExportDataTableButton";
import { CSVDownload } from "react-csv";

const { ExportCSVButton } = CSVExport;

export const initialFilter = {
  filter: {},
  q: "",
  sort: "asc",
  sortBy: "name",
  fromDate: "",
  toDate: "",
  skip: UIHelpers.skip,
  limit: UIHelpers.limit,
  page: UIHelpers.page,
};

const TournamentReports = (props) => {
  const csvHeader = [
    { label: "No.", key: "no" },
    { label: "TOURNAMENT ID",  key: "_id" },
    { label: "SHORT CODE",  key: "shortCode" },
    { label: "ASSIGNED TO",  key: "user.phone" },
    { label: "START DATE",  key: "startDate" },
    { label: "END DATE",  key: "endDate" },
    { label: "GAME",  key: "game.name" },
    { label: "GAME TYPE",  key: "gameType.name" },
    { label: "STATUS",  key: "status" },
    { label: "Is PRIVATE",  key: "isPrivate" }, //change heere
    { label: "TOURNAMENT TYPE",  key: "winningTerm" },
    { label: "ROUND",  key: "noOfRounds" },
    { label: "TOTAL CONTEST",  key: "totalContests" },
    { label: "PRIZEPOOL",  key: "prizePool" },
    { label: "DISTRIBUTED PRIZE POOL",  key: "totalWinningsDistributedCoin" },
    { label: "TOTAL WINNERS",  key: "totalWinners" },
    { label: "FINAL WINNERS",  key: "fWinners" },
    { label: "ENTRY FEE TYPE",  key: "currency.name" },
    { label: "ENTRY FEE",  key: "entryFee" },
    { label: "LJR",  key: "ljr" },
    { label: "TOTAL CAPACITY",  key: "totalPlayers" },
    { label: "TOTAL CAPACITY FILLED (ROUND 1)",  key: "totalJoinedPlayers" },
    { label: "EXTRA PLAYER’S",  key: "totalExtraPlayers" },
    { label: "UNIQUE HACKERS",  key: "totalhackers" },
    { label: "AVG RATINGS",  key: "avgRate" },
    { label: "TOTAL RATINGS",  key: "noOfRateing" },
    { label: "FINAL ROUND - ASSIGNEE",  key: "fAssignUser" },
    { label: "WINNING DECLARATION TIME",  key: "wdTime" },
    { label: "FINAL QAULIFY USER’S",  key: "fqUser" },
    { label: "FINAL JOINED USER’S COUNT",  key: "fjUser" },
    { label: "FINAL PLAYED USER’S COUNT",  key: "fpUser" },

    { label: "R1 - QAULIFY USER’S",  key: "r1qu" },
    { label: "R1 - JOINED USER’S",  key: "r1ju" },
    { label: "R1 - PLAYED USER’S",  key: "r1pu" },

    { label: "R2 - QAULIFY USER’S",  key: "r2qu" },
    { label: "R2 - JOINED USER’S",  key: "r2ju" },
    { label: "R2 - PLAYED USER’S",  key: "r2pu" },

    { label: "R3 - QAULIFY USER’S",  key: "r3qu" },
    { label: "R3 - JOINED USER’S",  key: "r3ju" },
    { label: "R3 - PLAYED USER’S",  key: "r3pu" },

    { label: "R4 - QAULIFY USER’S",  key: "r4qu" },
    { label: "R4 - JOINED USER’S",  key: "r4ju" },
    { label: "R4 - PLAYED USER’S",  key: "r4pu" },

    { label: "R5 - QAULIFY USER’S",  key: "r5qu" },
    { label: "R5 - JOINED USER’S",  key: "r5ju" },
    { label: "R5 - PLAYED USER’S",  key: "r5pu" },

    { label: "R6 - QAULIFY USER’S",  key: "r6qu" },
    { label: "R6 - JOINED USER’S",  key: "r6ju" },
    { label: "R6 - PLAYED USER’S",  key: "r6pu" },

    { label: "R7 - QAULIFY USER’S",  key: "r7qu" },
    { label: "R7 - JOINED USER’S",  key: "r7ju" },
    { label: "R7 - PLAYED USER’S",  key: "r7pu" },

    { label: "R8 - QAULIFY USER’S",  key: "r8qu" },
    { label: "R8 - JOINED USER’S",  key: "r8ju" },
    { label: "R8 - PLAYED USER’S",  key: "r8pu" },

    { label: "R9 - QAULIFY USER’S",  key: "r9qu" },
    { label: "R9 - JOINED USER’S",  key: "r9ju" },
    { label: "R9 - PLAYED USER’S",  key: "r9pu" },

    { label: "R10 - QAULIFY USER’S",  key: "r10qu" },
    { label: "R10 - JOINED USER’S",  key: "r10ju" },
    { label: "R10 - PLAYED USER’S",  key: "r10pu" },

    { label: "R11 - QAULIFY USER’S",  key: "r11qu" },
    { label: "R11 - JOINED USER’S",  key: "r11ju" },
    { label: "R11 - PLAYED USER’S",  key: "r11pu" },

    { label: "R12 - QAULIFY USER’S",  key: "r12qu" },
    { label: "R12 - JOINED USER’S",  key: "r12ju" },
    { label: "R12 - PLAYED USER’S",  key: "r12pu" },

    { label: "R13 - QAULIFY USER’S",  key: "r13qu" },
    { label: "R13 - JOINED USER’S",  key: "r13ju" },
    { label: "R13 - PLAYED USER’S",  key: "r13pu" },

    { label: "R14 - QAULIFY USER’S",  key: "r14qu" },
    { label: "R14 - JOINED USER’S",  key: "r14ju" },
    { label: "R14 - PLAYED USER’S",  key: "r14pu" },
  ];

  const { id } = useParams();
  let history = useHistory();
  const suhbeader = useSubheader();
  const dispatch = useDispatch();
  const [filter, setFilter] = useState(initialFilter);
  const [isContainerVisible, setIsContainerVisible] = useState(false);
  const [isDeleteShow, setIsDeleteShow] = useState(false);
  const [deleteItemRow, setDeleteItemRow] = useState(undefined);
  const [count, setCount] = useState(0);
  const [columns, setColumns] = useState([]);
  const [isCheck, setIsCheck] = useState(false);
  const [contestForSelectedDropdownFilterData, setContestForListDropdownFilterData] = useState([]);
  const [contestForDropdownFilterData, setContestForDropdownFilterData] = useState([]);

  const [dateRange, setDateRange] = useState({
    from: moment(new Date().setHours(0, 0, 0, 0)),
    to: moment(new Date().setHours(23, 59, 59, 0)),
  });

  suhbeader.setTitle("Tournaments Report");

  const onPageChange = (page, sizePerPage) => {
    filter.limit = sizePerPage;
    filter.page = 1;
    setFilter(filter);
    setCount(count + 1);
  };

  const onSizePerPageChange = (sizePerPage, page) => {
    filter.limit = sizePerPage;
    filter.page = 1;
    setFilter(filter);
    setCount(count + 1);
  };

  const filterChange = (filterData) => {
    filter.q = filterData.q;
    filter.filter = filterData.filter;
    setFilter(filter);
    setCount(count + 1);
  };

  const { currentState, companySelection } = useSelector(
    (state) => ({
      currentState: state.tournamentsSlice,
      companySelection: state.searchList,
    }),
    shallowEqual
  );
  const { companyData, exportData } = companySelection;
  // console.log(companyData);
  const { actionsLoading, contestUsers, listLoading, tournamentReportData, companyDropdownList } = currentState;

  const { totalCount, entities } = tournamentReportData;

  useEffect(() => {
    dispatch(actions.fetchCompanyDropdownList());
  }, []);
  useEffect(() => {
    console.log("company list", companyDropdownList);
    if (companyDropdownList && companyDropdownList?.data) {
      let temp = [];
      const userdata = JSON.parse(localStorage.getItem("userData"));
      const userCompany = userdata?.company || [];
      companyDropdownList.data.forEach((element, i) => {
        // console.log(userCompany.includes(element._id));
        // console.log(!helperFunc.isAdmin());
        // if (!helperFunc.isAdmin()) {
        if (userCompany.includes(element._id)) {
          //     temp.push({
          //       _id: i + 1,
          //       label: element.name,
          //       value: element._id,
          //       code: element.code
          //     })
          //   }
          // } else {
          temp.push({
            _id: i + 1,
            label: element.name,
            value: element._id,
            code: element.code,
          });
        }
      });
      setContestForDropdownFilterData(temp);
    }
  }, [companyDropdownList]);

  useEffect(() => {
    const columns = [
      {
        dataField: "eventId",
        text: "Tournament Id",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.TournamentLinkColumnFormatter,
        formatExtraData: {
          dIndexName: "eventId",
        },
      },
      {
        dataField: "shortCode",
        text: "Short Code",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "assignedTo",
        text: "Assigned To",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.ArrayToCommaSaperatorColumnFormatter,
        csvFormatter: columnFormatters.ArrayToCommaSaperatorColumnFormatter,
      },
      {
        dataField: "startDate",
        text: "Start Date",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.DateDynamicColumnFormatter,
        formatExtraData: {
          dIndexName: "startDate",
          formate: "lll",
        },
      },
      {
        dataField: "endDate",
        text: "End Date",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.DateDynamicColumnFormatter,
        formatExtraData: {
          dIndexName: "endDate",
          formate: "lll",
        },
      },
      {
        dataField: "game.name",
        text: "Game",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "gameType.name",
        text: "Game Type",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "status",
        text: "Status",
        sort: false,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.ContestStatusColumnFormatter,
      },
      {
        dataField: "isVisible",
        text: "Public / Private",
        sort: false,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.EventPPColumnFormatter,
        csvFormatter: columnFormatters.EventPPColumnFormatter,
      },
      {
        dataField: "winningTerm",
        text: "Tournament Type",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "noOfRounds",
        text: "Round",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "totalContests",
        text: "Total Contest",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.IfundefinedColumnFormatter,
        csvFormatter: columnFormatters.IfundefinedColumnFormatter,
      },
      {
        dataField: "prizePool",
        text: "Prizepool",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "totalWinningsDistributed", // winning amount
        text: "Distributed Prize pool",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.IfundefinedColumnFormatter,
        csvFormatter: columnFormatters.IfundefinedColumnFormatter,
      },
      {
        dataField: "totalWinners",
        text: "Total Winners",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "totalActualWinners",
        text: "Final Winners",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.IfundefinedColumnFormatter,
        csvFormatter: columnFormatters.IfundefinedColumnFormatter,
      },
      {
        dataField: "contestFor", //in response currency arry for in and out
        text: "Entry Fee Type",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.EntryFeeTypeColumnFormatter,
        csvFormatter: columnFormatters.EntryFeeTypeColumnFormatter,
      },
      {
        dataField: "entryFee",
        text: "Entry Fee",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "ljr",
        text: "LJR",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "totalPlayers",
        text: "Total Capacity",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "uniqueUserCount",
        text: "Total First Time Joined Users",
        sort: true,
        show: true,
        format: {},
      },
      {
        dataField: "totalJoinedPlayers",
        text: "Total Capacity Filled (Round 1)",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "totalExtraPlayers",
        text: "Extra Player’s",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "totalhackers",
        text: "Unique Hackers",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "avgRate",
        text: "AVG Ratings",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "noOfRateing", //rating comming undefined also in column 1
        text: "Total Ratings",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.IfundefinedColumnFormatter,
        csvFormatter: columnFormatters.IfundefinedColumnFormatter,
      },
      {
        dataField: "fAssignUser",
        text: "Final Round - Assignee",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.IfundefinedColumnFormatter,
        csvFormatter: columnFormatters.IfundefinedColumnFormatter,
      },
      {
        dataField: "wdTime",
        text: "Winning Declaration Time",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.DateDynamicColumnFormatter,
        formatExtraData: {
          dIndexName: "wdTime",
          formate: "lll",
        },
        csvFormatter: columnFormatters.DateDynamicColumnFormatter,
      },
      {
        dataField: "fqUser",
        text: "final qaulify User’s",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "fjUser",
        text: "final Joined User’s Count",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.IfundefinedColumnFormatter,
        csvFormatter: columnFormatters.IfundefinedColumnFormatter,
      },
      {
        dataField: "fpUser",
        text: "final Played User’s Count",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.IfundefinedColumnFormatter,
        csvFormatter: columnFormatters.IfundefinedColumnFormatter,
      },
    ];

    for (var i = 1; i < 15; i++) {
      var var1 = {
        dataField: `r${i}qu`,
        text: `R${i} - Qaulify User’s`,
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.IfundefinedColumnFormatter,
        csvFormatter: columnFormatters.IfundefinedColumnFormatter,
      };
      var var2 = {
        dataField: `r${i}ju`,
        text: `R${i} - Joined User’s`,
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.IfundefinedColumnFormatter,
        csvFormatter: columnFormatters.IfundefinedColumnFormatter,
      };
      var var3 = {
        dataField: `r${i}pu`,
        text: `R${i} - Played User’s`,
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.IfundefinedColumnFormatter,
        csvFormatter: columnFormatters.IfundefinedColumnFormatter,
      };

      columns.push(var1);
      columns.push(var2);
      columns.push(var3);
    }
    setColumns(columns);
  }, []);

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: UIHelpers.sizePerPageList,
    sizePerPage: filter.limit,
    page: filter.page,
    // onPageChange : onPageChange,
    onSizePerPageChange: onSizePerPageChange,
  };

  const applyFilter = (values, type) => {
    // console.log("--------------------------------------value",values)
    var tampFilter = { ...filter };
    // if (type === "isApply") {
    //   if (!values.target.checked) {
    //     setIsCheck(false);
    //     return false;
    //   }
    //   tampFilter.fromDate = undefined;
    //   tampFilter.toDate = undefined;
    //   tampFilter.type = "todayData";
    //   setFilter(tampFilter);
    //   setCount(count + 1);
    //   setIsCheck(true);
    // } else {
    if (!values?.dateRang?.from || !values?.dateRang?.to) {
      NotificationManager.error("Please Select From Date and To Date", "Error");
      return;
    }
    if (contestForSelectedDropdownFilterData == null || contestForSelectedDropdownFilterData.length <= 0) {
      NotificationManager.error("Please select company", "Error");
      return false;
    } else {
      tampFilter.company = contestForSelectedDropdownFilterData?.code;
      tampFilter.filter.company = contestForSelectedDropdownFilterData?.value;
    }
    tampFilter.fromDate = values?.dateRang?.from;
    tampFilter.toDate = values?.dateRang?.to;
    // tampFilter.type = undefined;
    tampFilter.type = "todayData";
    setFilter(tampFilter);
    setCount(count + 1);
    //  }
    dispatch(actions.fetchTournamentReport(tampFilter));
  };
  const exportButtonCSVAPICall = () => {
    var tampFilter = { ...filter };
    tampFilter.page = 1;
    tampFilter.limit = totalCount;
     dispatch(actions.fetchTournamentReportExport(tampFilter));
  };
  const createFormInputs = () => {
    return (
      <div className="report-filter-bLock border-0 row align-items-center"
      style={{ padding: "0px 0", margin: "0px" }}>
        <Formik
          initialValues={{ dateRang: dateRange }}
          onSubmit={(values) => {
            applyFilter(values);
          }}
        >
          {({ handleSubmit, values }) => (
             <div className="col-lg-12 col-md-9">
            <form onSubmit={handleSubmit} className="form form-filter w-100" autoComplete="off">
              <div className="form-group row m-0 align-items-center">
              <div
                    className="col-lg-4 col-md-6 pl-0 mt-2"
                    style={{
                      // maxWidth: "325px",
                      position: "relative",
                      top: "-9px",
                    }}
                  >
                  <label>Select Company</label>
                  <DropdownReactSelect
                    placeholder={"Company"}
                    name={"Company"}
                    value={contestForSelectedDropdownFilterData}
                    // isMulti={values.isShared == 'true' ? true : false}
                    isMulti={false}
                    isClearable={true}
                    isSearchable={true}
                    closeMenuOnSelect={true}
                    options={contestForDropdownFilterData}
                    onChange={setContestForListDropdownFilterData}
                  />
                </div>
                <div
                    className="col-lg-4 col-md-6 pl-0 mt-2"
                    style={{
                      // maxWidth: "250px",
                      position: "relative",
                      top: "-9px",
                    }}
                  >
                  <DateRangPickerField name="dateRang" placeholder="Select Date Rang" label="Date Rang" dateRang={dateRange} />
                </div>

                {helperFunc.isButtonAccess("reports.gamerjiTournamentReports.list") && (
                  <div className="justify-content-end">
                     <button
                        type="submit"
                        className="btn btn-dark"
                        style={{
                          width: "130px",
                          position: "relative",
                          top: "3px",
                        }}
                      >
                      Search
                    </button>
                  </div>
                )}
              </div>
            </form></div>
          )}
        </Formik>
        <div className="col-lg-3 col-md-3 d-flex justify-content-end">
          <div className="d-flex px-4">
            {entities.length > 0 && (
              <div className="d-flex align-items-center" style={{ position: "relative", top: "3px" }}>
                {helperFunc.isButtonAccess("reports.gamerjiTournamentReports.export") && (
                  <ExportDataTableButton 
                  isabled={listLoading} 
                  typeOfExportDataTable={["CSV"]} 
                  exportButtonCSVAPICall={exportButtonCSVAPICall} />
                )}
                 
              </div>
            )}

          </div>
        </div>
      </div>
    );
  };

  return (
    <>
     
      <Card className="">
      <NotificationContainer />
      <div className="card-header p-0">
        <div className="my-5 w-100 row mx-auto">
        {createFormInputs()}
        </div>
        </div>
        <CardBody className="p-0">

          { listLoading === false && totalCount === 0 ? (
            UIHelpers.dataTableNoData()
          ):(entities && entities.length  &&  columns && columns.length > 0) ? (
            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
              {({ paginationProps, paginationTableProps }) => {
                return (
                  <Pagination isLoading={listLoading} paginationProps={paginationProps}>
                    <ToolkitProvider
                      keyField="id"
                      data={entities ? entities : []}
                      columns={columns}
                      exportCSV={{
                        fileName: "TournamentsReport.csv",
                      }}
                    >
                      {(props) => (
                        <div>
                          <BootstrapTable
                            wrapperClasses="table-responsive"
                            bordered={false}
                            classes="table table-bordered table-head-custom table-vertical-center overflow-hidden"
                            bootstrap4
                            // remote
                            keyField="_id"
                            data={entities ? entities : []}
                            columns={columns}
                            {...props}
                            {...paginationTableProps}
                            {...props.baseProps}
                          >
                            <PleaseWaitMessage entities={entities} />
                            <NoRecordsFoundMessage entities={entities} />
                          </BootstrapTable>
                        </div>
                      )}
                    </ToolkitProvider>
                  </Pagination>
                );
              }}
            </PaginationProvider>
          ):<></>} 
        </CardBody>
      </Card>
    </>
  );
};

export default TournamentReports;
